import { SafeDictionary } from "@insite/client-framework/Common/Types";
import { addToChainAfter, createHandlerChainRunner, Handler, HandlerWithResult, replaceInChain } from "@insite/client-framework/HandlerCreator";
import { GetProductCollectionApiV2Parameter, ProductExpandTokens } from "@insite/client-framework/Services/ProductServiceV2";
import {
    chain,
    DispatchSetFilterQuery,
    DisplayProductsResult,
    GetUnfilteredProducts,
    HandleSortOrderDefault,
    ParseQueryParameter,
    RemoveNotAvailableAttributeValues,
} from "@insite/client-framework/Store/Pages/ProductList/Handlers/DisplayProducts";
import setFilterQuery from "@insite/client-framework/Store/Pages/ProductList/Handlers/SetFilterQuery";
import { ProductFilters } from "@insite/client-framework/Store/Pages/ProductList/ProductListState";
import { CustomProductFilters } from "@tSurya/Handlers/ProductList/AddProductAvailibility";
import CustomApplicationState from "@tSurya/Store/Data/CustomApplicationState/CustomApplicationState";
import qs from "qs";
import { setCookie } from "@insite/mobius/utilities/cookies";

export interface CustomDisplayProductsResult extends Omit<DisplayProductsResult, "productFilters"> {
    productFilters: CustomProductFilters;
}

interface Parameter {
    queryString?: string;
    path: string;
    isSearch: boolean;
}

interface Props {
    apiParameter: GetProductCollectionApiV2Parameter;
    idByPath?: SafeDictionary<string>;
    result: CustomDisplayProductsResult;
    pricingLoaded?: true;
    expandTokens?: ProductExpandTokens;
}

type HandlerType = Handler<Parameter, Props>;
const productListSortTypeCookie = "productListSortType";

export const ProductAvailibilityQueryParams: HandlerType = props => {
    const queryString = props.parameter.queryString || "";
    const parsedQuery = qs.parse(queryString.startsWith("?") ? queryString.substr(1) : queryString);
    props.result.productFilters = {
        ...props.result.productFilters,
        minimumPrice:
            typeof parsedQuery.minimumPrice === "string"
                ? parsedQuery.minimumPrice
                : Array.isArray(parsedQuery.minimumPrice)
                  ? String(parsedQuery.minimumPrice[0])
                  : parsedQuery.minimumPrice !== undefined
                    ? String(parsedQuery.minimumPrice)
                    : undefined,
    };
};

export const RemoveNotAvailableAttributeValuesExtended: HandlerType = props => {
    // const productsDataView = getProductsDataView(props.getState(), props.apiParameter);
    // if (!productsDataView.value) {
    //     return;
    // }
    // const possibleAttributeValueIds = new Set();
    // productsDataView?.attributeTypeFacets?.forEach(a =>
    //     a.attributeValueFacets?.forEach(v => possibleAttributeValueIds.add(v.attributeValueId)),
    // );
    // const removedAttributeValueIds = props.result.productFilters.attributeValueIds?.filter(
    //     o => !possibleAttributeValueIds.has(o),
    // );
    // if (
    //     removedAttributeValueIds?.length &&
    //     !props.result.productFilters.stockedItemsOnly &&
    //     !props.result.productFilters.previouslyPurchasedProducts
    // ) {
    //     const attributeValueIds = props.result.productFilters.attributeValueIds?.filter(o =>
    //         possibleAttributeValueIds.has(o),
    //     );
    //     // props.dispatch(removeProductFilters({ attributeValueIds: removedAttributeValueIds }));
    //     const parsedQuery = parseQueryString<any>(props.parameter.queryString);
    //     parsedQuery.attributeValueIds = attributeValueIds?.length ? attributeValueIds.join(",") : undefined;
    //     const parameter = { ...props.parameter, queryString: qs.stringify(parsedQuery) };
    //     // props.dispatch(displayProducts(parameter));
    //     return false;
    // }
};

export const GetUnfilteredProductsExtended: HandlerType = props => {
    const unfilteredApiParameter = { ...props.apiParameter };
    // delete unfilteredApiParameter.searchWithin;
    // if (!props.result.productFilters.pageBrandId) {
    //     delete unfilteredApiParameter.brandIds;
    // }
    // if (!props.result.productFilters.pageProductLineId) {
    //     delete unfilteredApiParameter.productLineIds;
    // }
    // delete unfilteredApiParameter.priceFilters;
    // delete unfilteredApiParameter.attributeValueIds;
    // if (!props.result.productFilters.pageCategoryId) {
    //     delete unfilteredApiParameter.categoryId;
    // }
    // unfilteredApiParameter.stockedItemsOnly = undefined;
    // unfilteredApiParameter.previouslyPurchasedProducts = undefined;
    // if(props.apiParameter.attributeValueIds){
    //     props.result.productFilters.attributeValueIds = props.apiParameter.attributeValueIds;
    // }
    // if(props.apiParameter.brandIds){
    //     props.result.productFilters.brandIds = props.apiParameter.brandIds;
    // }
    // if(props.apiParameter.categoryId){
    //     props.result.productFilters.categoryId = props.apiParameter.categoryId;
    // }

    props.result.unfilteredApiParameter = unfilteredApiParameter;
    props.result.filteredApiParameter = { ...props.apiParameter };

    // const unfilteredProducts = getProductsDataView(props.getState(), unfilteredApiParameter).value;

    // if (unfilteredProducts) {
    //     return;
    // }

    // await executeAwaitableHandlerChain(loadProducts, unfilteredApiParameter, props);
};

export const DispatchSetFilterQueryExtended: HandlerType = props => {
    // const state = props.getState() as CustomApplicationState;
    // props.dispatch(setFilterQuery());
    // // if(state.SURData.loadMore.loadMore){
    // // }
};
export const CustomHandleSortOrderDefault: HandlerType = props => {
    if (props.apiParameter.sort) {
        setCookie(productListSortTypeCookie, props.apiParameter.sort);
    }
};

replaceInChain(chain, HandleSortOrderDefault, CustomHandleSortOrderDefault);
addToChainAfter(chain, ParseQueryParameter, ProductAvailibilityQueryParams);
replaceInChain(chain, RemoveNotAvailableAttributeValues, RemoveNotAvailableAttributeValuesExtended);
replaceInChain(chain, GetUnfilteredProducts, GetUnfilteredProductsExtended);
replaceInChain(chain, DispatchSetFilterQuery, DispatchSetFilterQueryExtended);
